import React, { useEffect, useMemo, useState } from 'react';
import ContactDeleteDialog from '@medflex/components/stories/ContactDeleteDialog';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showAlertToast, showSuccessToast } from '@medflex/components/stories/Toast';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';
import useChatContacts from '../hooks/useChatContacts';
import useModal from '../hooks/useModal';

const ContactDeleteModule = () => {
  const { t } = useTranslation('global');
  const { contactId } = useLocationSearchParams();
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();
  const { contacts = [] } = useChatContacts();
  const { close: closeModal } = useModal();
  const isDeleting = useSelector(state => state.loading.effects.chatContacts.delete);
  const { errors } = useSelector(state => ({
    errors: state.errors.chat_contacts,
  }));
  const contact = useMemo(() => contacts.find(({ id }) => id === contactId), [contacts]);

  const handleConfirm = () => {
    dispatch.chatContacts.delete({ contactId });
  };

  const handleCancel = () => {
    closeModal({ modal: 'deleteContact', contactId });
  };

  useEffect(() => {
    if (isDeleting && !submitted) {
      setSubmitted(true);
    }

    if (!isDeleting && submitted) {
      if (!errors) {
        showSuccessToast(t('ContactDeleteModule.toast.success.title'), null, {
          toastId: 'contactDeleteSuccess',
        });
      } else {
        showAlertToast(
          t('ContactDeleteModule.toast.failure.title'),
          t('ContactDeleteModule.toast.failure.description'),
          { toastId: 'contactDeleteFailed' },
        );
      }
      closeModal({ modal: 'deleteContact', contactId });
    }
  }, [isDeleting, submitted, errors]);

  if (!contact) return null;

  return (
    <ContactDeleteDialog
      name={contact.user.fullNameWithTitle}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      isLoading={isDeleting}
    />
  );
};

export default ContactDeleteModule;
